module.exports = __webpack_public_path__ + "static/media/kepian.93d12af3.png";